import ProductTile from "./ProductTile";

export default ProductTile;
